import React from "react";
import { KatAlert } from "@amzn/katal-react";

interface ErrorStatusProps {
    readonly header?: string,
    readonly description?: string,
    readonly className?: string,
}

const ErrorStatusComponent = ({ header = "", description = "", className = "alertStyle" }: ErrorStatusProps) => {

    return (
        <>
            <div>
                <KatAlert
                    description={description}
                    header={header}
                    variant="warning"
                    persistent
                    className={className}
                />
            </div>
        </>
    )
};

export default ErrorStatusComponent;
